interface ConfigErrorProps {
  error: Error
}

export function ConfigError({ error }: ConfigErrorProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-6 font-sans text-foreground">
      <div className="max-w-[400px] text-center">
        <div className="mb-4 text-5xl">⚠️</div>
        <h1 className="mb-3 text-xl font-semibold">Configuration Error</h1>
        <p className="mb-6 text-sm text-muted-foreground">{error.message}</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="cursor-pointer rounded-lg border-none bg-white px-6 py-3 text-sm font-medium text-background"
        >
          Retry
        </button>
      </div>
    </div>
  )
}
